module.exports = __webpack_public_path__ + "static/media/screen_gallery_plus_16.2a86475a.svg";